'use strict';

angular.module('login')

.config(function ($stateProvider)
{
    $stateProvider
        .state('guest.login', {
            url: '/login',
            templateUrl: 'modules/login/login.html',
            controller: function ($scope, kdLogin)
            {
                $scope.loginHandler = function ()
                {
                    kdLogin.afterLoginRedirect();
                };
            }
        });
});
